module.exports = __webpack_public_path__ + "img/video-player/gradient-94633672feb8a4f309b7f785722eaad3.png";